'use client';

import { useRouter } from 'next/navigation';
import type {
  TourFeedbackPrompt as TourFeedbackPromptData,
  TourFeedbackSuccessVariant,
} from '@repo/utils';
import { Button } from '@/components/ui/Button';
import { Divider } from '@/components/ui/Divider';
import { useAnalytics } from '@/hooks/useAnalytics';
import { TourFeedbackPropertyCard } from './TourFeedbackPropertyCard';

const LISTING_RESULTS_PATH = '/listings/status:verified';

function buildApplicationUrl(slug: string) {
  return `/profile/application-profile?tab=basic-info&substep=PHI0&unit=${encodeURIComponent(slug)}`;
}

export function TourFeedbackSuccess({
  prompt,
  variant,
  onDone,
}: {
  prompt: TourFeedbackPromptData;
  variant: TourFeedbackSuccessVariant;
  onDone: () => void;
}) {
  const router = useRouter();
  const analytics = useAnalytics();

  if (variant === 'apartment') {
    const slug = prompt.unit.slug;

    const handleApply = () => {
      analytics.track('tour_feedback_apply');
      if (slug) router.push(buildApplicationUrl(slug));
      onDone();
    };

    return (
      <div className="flex flex-col gap-4">
        <p className="text-heading-6 text-primary">Thanks for your feedback!</p>
        <Divider />
        <p className="text-body-2-high text-secondary">Interested in this apartment?</p>
        <TourFeedbackPropertyCard prompt={prompt} />
        <Button fullWidth onClick={handleApply}>
          Apply now
        </Button>
      </div>
    );
  }

  const handleBrowse = () => {
    analytics.track('tour_feedback_browse');
    router.push(LISTING_RESULTS_PATH);
    onDone();
  };

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-1">
        <p className="text-heading-6 text-primary">Thanks for your feedback!</p>
        <p className="text-caption text-secondary">This helps us improve your experience.</p>
      </div>
      <Button fullWidth onClick={handleBrowse}>
        Browse more apartments
      </Button>
    </div>
  );
}
